import { useEffect } from 'react';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import ErrorBoundary from '@components/shared/ErrorBoundary/ErrorBoundary';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/p')({
  component: PartnerLayout,
});

function PartnerLayout() {
  const navigate = useNavigate();
  const organizationType = useAuthStore((s) => s.organizationType);
  const userType = useAuthStore((s) => s.userType);

  // Org type guard — only PARTNER users can access /p routes
  useEffect(() => {
    if (!organizationType) return;
    if (userType === 'EMPLOYEE' || organizationType !== 'PARTNER') {
      void navigate({ to: '/', replace: true });
    }
  }, [organizationType, userType, navigate]);

  // Block render until the auth store is hydrated — see w.tsx for the
  // same-frame leak rationale.
  if (!organizationType || !userType) return null;
  if (organizationType !== 'PARTNER' || userType === 'EMPLOYEE') return null;

  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
}
